import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const Pagination = ({ pages }) => {
  const { titleNext, linkNext, titlePrev, linkPrev } = pages
  return (
    <div className="pagination my-5 d-flex justify-content-between flex-column flex-xs-row">
      <div>
        {linkPrev && (
          <a href={`https://ciudadania.pe/actividades-interactivas/${linkPrev}`}>
            <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> {titlePrev}
          </a>
        )}
      </div>
      <div>
        {linkNext && (
          <a href={`https://ciudadania.pe/actividades-interactivas/${linkNext}`}>
            {titleNext} <FontAwesomeIcon icon={faArrowRight} />
          </a>
        )}
      </div>
    </div>
  );
};

export default Pagination;
